// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"302":"penilaian/regu","333":"penilaian/tunggal","491":"pertandingan","503":"penilaian/ganda","826":"index"}[chunkId] + "." + {"302":"e8c7c4ee","333":"65f2c885","491":"e7c068b9","503":"d74ea1af","826":"09ec07d3"}[chunkId] + ".js";
};